import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { getJobManagerTableFilterOptions } from 'modules/jobManager/utils';
import { getJobManagerTableFilter } from 'modules/jobManager/ducks/selectors';
import { ALIGNMENT, Menu, MenuItemOption } from 'ui/menu';
import { GhostButton } from 'ui/button';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { clearJobFilterState, setJobFilterState } from 'modules/jobManager/ducks/actions';
import { TABLE_FILTER } from 'modules/jobManager/types';

export const FilterButton = () => {
  const { t, ct, ready } = useJobManagerTranslations();
  const dispatch = useDispatch();
  const { jobStates, jobTypeNames } = useSelector(getJobManagerTableFilter);
  const [menuOptions, setMenuOptions] = useState<MenuItemOption[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  const handleSelectionChange = (selectedId: string) => {
    const [tableFilter, value] = selectedId.split(/-(.*)/s);
    const key = tableFilter;
    let existingFilterValues: string[] = [];

    switch (tableFilter as TABLE_FILTER) {
      case TABLE_FILTER.JOB_STATES: {
        existingFilterValues = jobStates;
        break;
      }

      case TABLE_FILTER.JOB_TYPE_NAMES: {
        existingFilterValues = jobTypeNames;
        break;
      }

      default:
        return;
    }

    dispatch(
      setJobFilterState({
        [key]: existingFilterValues.includes(value)
          ? existingFilterValues.filter((item) => item !== value)
          : [...existingFilterValues, value],
      }),
    );
  };

  const clearSelectedFilters = () => dispatch(clearJobFilterState());

  useEffect(() => {
    setMenuOptions(
      getJobManagerTableFilterOptions({
        t,
        hasJobStatusSelected: !!jobStates.length,
        hasJobTypeSelected: !!jobTypeNames.length,
      }),
    );
  }, [ready, !!jobStates.length, !!jobTypeNames.length]);

  useEffect(() => {
    setSelectedFilters([
      ...jobStates.map((item) => `${TABLE_FILTER.JOB_STATES}-${item}`),
      ...jobTypeNames.map((item) => `${TABLE_FILTER.JOB_TYPE_NAMES}-${item}`),
    ]);
  }, [jobStates.length, jobTypeNames.length]);

  return (
    <>
      {selectedFilters.length > 0 && (
        <GhostButton data-test="clear-filters-button" onClick={clearSelectedFilters}>
          {ct('button.clear')}
        </GhostButton>
      )}
      <Menu
        data-test="job-index-filter-button"
        isSelectMenu
        horizontalAlignment={ALIGNMENT.RIGHT}
        options={menuOptions}
        defaultSelectedOptionIds={selectedFilters}
        handleSelectionChange={handleSelectionChange}
      >
        <FilterMenuTriggerButton selectedFilterCount={selectedFilters.length} />
      </Menu>
    </>
  );
};
